import Modal from 'react-modal';
import ReactDOM from 'react-dom/client';
import React, { Suspense } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import '@fortawesome/fontawesome-free/css/all.min.css';
import '@uni-of-exeter/digital.lib.react.ui.kit/dist/styles/variables.css';
import '@uni-of-exeter/digital.lib.react.ui.kit/dist/styles/typography.css';
import '@uni-of-exeter/digital.lib.react.ui.kit/dist/styles/colour-tokens.css';
import '@uni-of-exeter/digital.lib.react.ui.kit/dist/digital.lib.react.ui.kit.cjs.development.css';

import App from './app';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <Suspense>
          <App />
        </Suspense>
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);
Modal.setAppElement('#modal-root');
